var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 37,
    viewBox: "0 0 22 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4 1.42962L20.8 9.69963C21.1791 10.0713 21.4805 10.5147 21.6865 11.004C21.8926 11.4933 21.9991 12.0187 22 12.5496V33.0496C22 33.8453 21.6839 34.6083 21.1213 35.1709C20.5587 35.7336 19.7956 36.0496 19 36.0496H3C2.20435 36.0496 1.44129 35.7336 0.878679 35.1709C0.31607 34.6083 0 33.8453 0 33.0496V12.5496C0.000872912 12.0187 0.107429 11.4933 0.313454 11.004C0.519479 10.5147 0.820851 10.0713 1.2 9.69963L9.6 1.42962C9.97386 1.06317 10.4765 0.85791 11 0.85791C11.5235 0.85791 12.0261 1.06317 12.4 1.42962ZM11 7.04963C10.2044 7.04963 9.44129 7.3657 8.87868 7.92831C8.31607 8.49092 8 9.25398 8 10.0496C8 10.8453 8.31607 11.6083 8.87868 12.1709C9.44129 12.7336 10.2044 13.0496 11 13.0496C11.7956 13.0496 12.5587 12.7336 13.1213 12.1709C13.6839 11.6083 14 10.8453 14 10.0496C14 9.25398 13.6839 8.49092 13.1213 7.92831C12.5587 7.3657 11.7956 7.04963 11 7.04963Z",
    fill: "#1943DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature1);
export default __webpack_public_path__ + "static/media/feature1.d20c04d6fb83a6c32ff2f1876e2a7bb6.svg";
export { ForwardRef as ReactComponent };